var _rect, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJiraCaption(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 82,
    height: 82,
    rx: 7.5,
    stroke: "#E0E0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.6239 26.7856H39.2559C39.2559 30.6176 42.3615 33.7232 46.1935 33.7232H49.0239V36.456C49.0271 40.2848 52.1295 43.3872 55.9567 43.3888V28.1184C55.9567 27.3824 55.3599 26.7856 54.6239 26.7856Z",
    fill: "#2684FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0194 34.4434H31.6514C31.653 38.2722 34.757 41.3746 38.5842 41.3762H41.4146V44.1186C41.4194 47.9474 44.5234 51.0466 48.3522 51.0466V35.7762C48.3538 35.0402 47.757 34.4434 47.0194 34.4434Z",
    fill: "url(#paint0_linear_1_68257)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.411 42.0962H24.043C24.043 45.9282 27.1486 49.0338 30.9806 49.0338H33.8206V51.7666C33.8238 55.5906 36.9198 58.693 40.7454 58.6994V43.429C40.7438 42.693 40.147 42.0962 39.411 42.0962Z",
    fill: "url(#paint1_linear_1_68257)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_68257",
    x1: 48.0247,
    y1: 34.4675,
    x2: 41.5284,
    y2: 41.2468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_68257",
    x1: 40.8536,
    y1: 42.1689,
    x2: 33.3385,
    y2: 49.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJiraCaption);
export default __webpack_public_path__ + "static/media/jira-caption.227b167019ab437c0a5f9cb68b767e79.svg";
export { ForwardRef as ReactComponent };